/*
 * @Author: Yran
 * @Date: 2021-05-19 18:07:59
 * @LastEditors: Yran
 * @LastEditTime: 2021-05-19 19:12:06
 */
import axios from '@/utils/axios';
const apiUrl = {
    getUserList: 'sys/user/list',
    updateUser: 'sys/user/updateUserRoles',
};
export function getUserListData(params) {
    return axios.post(apiUrl.getUserList, params);
}
export function updateUserData(params) {
    return axios.post(apiUrl.updateUser, params);
}